import { makePath } from "../../../url";
import { postFile } from "../../request";
import { APIContext } from "../../types";

export type BlobAPI = ReturnType<typeof createBlobAPI>;

export function createBlobAPI({ buildURL, fetchRaw }: APIContext) {
  function fetchBlob(blobURL: URL) {
    const request = new Request(blobURL.toString());
    return fetchRaw(request);
  }

  function fetchImmutableScanBlob({
    patientId,
    scanId,
    scanVersion,
    resultName,
    path: filePath,
  }: {
    patientId: string;
    scanId: string;
    scanVersion: string | "latest";
    resultName: string;
    path: string;
  }) {
    const path = makePath([
      "api",
      "v1",
      "scan",
      patientId,
      scanId,
      "version",
      scanVersion,
      "result",
      resultName,
      "blob",
      filePath,
    ]);
    const url = buildURL(path);
    return fetchBlob(url);
  }

  function fetchRecordingBlob({
    deviceId,
    recordingId,
    path: filePath,
  }: {
    deviceId: string;
    recordingId: string;
    path: string;
  }) {
    const path = makePath([
      "api",
      "v1",
      "blob",
      "recording",
      deviceId,
      recordingId,
      filePath,
    ]);
    const url = buildURL(path);
    return fetchBlob(url);
  }

  function fetchPatientBlob({
    patientId,
    path: filePath,
  }: {
    patientId: string;
    path: string;
  }) {
    const path = makePath([
      "api",
      "v1",
      "blob",
      "patient",
      patientId,
      filePath,
    ]);
    const url = buildURL(path);
    return fetchBlob(url);
  }

  function putImmutableScanBlob({
    patientId,
    scanId,
    scanVersion,
    resultName,
    path: filePath,
    file,
  }: {
    patientId: string;
    scanId: string;
    scanVersion: string | "latest";
    resultName: string;
    path: string;
    file: Blob;
  }) {
    const path = makePath([
      "api",
      "v1",
      "scan",
      patientId,
      scanId,
      "version",
      scanVersion,
      "result",
      resultName,
      "blob",
      filePath,
    ]);
    const url = buildURL(path);
    const request = postFile(url, file);

    return fetchRaw(request);
  }

  function putRecordingBlob({
    deviceId,
    recordingId,
    file,
    path: filePath,
  }: {
    deviceId: string;
    recordingId: string;
    file: Blob;
    path: string;
  }) {
    const path = makePath([
      "api",
      "v1",
      "blob",
      "recording",
      deviceId,
      recordingId,
      filePath,
    ]);
    const url = buildURL(path);
    const request = postFile(url, file);

    return fetchRaw(request);
  }

  function putPatientBlob({
    patientId,
    file,
    path: filePath,
  }: {
    patientId: string;
    file: Blob;
    path: string;
  }) {
    const path = makePath([
      "api",
      "v1",
      "blob",
      "patient",
      patientId,
      filePath,
    ]);
    const url = buildURL(path);
    const request = postFile(url, file);

    return fetchRaw(request);
  }

  return {
    fetchImmutableScanBlob,
    putImmutableScanBlob,
    fetchRecordingBlob,
    putRecordingBlob,
    fetchPatientBlob,
    putPatientBlob,
  };
}
